import { render } from "./SurveyCard.base.functional.vue?vue&type=template&id=0ca10506"
const script = {}

import "./SurveyCard.base.functional.vue?vue&type=style&index=0&id=0ca10506&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__